// import Swal from 'sweetalert2'

// export const confirmDialog = async (message, icon, textColor, tittleText) => {
//   const result = await Swal.fire({
//     title: tittleText,
//     // text: message,
//     html: message.replace(/\n/g, '<br>'),
//     icon: icon,
//     confirmButtonText: 'باشه',
//     color: textColor
//   });

//   return result.isConfirmed;
// };

import Swal from 'sweetalert2'

export const confirmDialog = async (
  message,
  icon,
  titleText,
  titleColor = '#2563eb',
  messageColor = '#374151'
) => {
  const result = await Swal.fire({
    icon,
    confirmButtonText: 'باشه',
    html: `
      <h2 style="color: ${titleColor}; margin: 0 0 12px 0; font-size: 22px;">
        ${titleText}
      </h2>
      <div style="color: ${messageColor}; line-height: 1.9; white-space: pre-line;">
        ${message}
      </div>
    `
  });

  return result.isConfirmed;
};

